import { useParams } from 'react-router-dom';

import { USER_TYPES } from 'shared_DEPRECATED/types/User';

import { useOpenPrioritizedModal } from 'features/goal/hooks/useOpenPrioritizeGoalsModal';
import { useOpenPrioritizedGoalsLimitReachedModal } from 'features/goal/hooks/useOpenPrioritizedGoalsLimitReachedModal';
import { usePrioritizedGoalsLimitReached } from 'features/goal/hooks/usePrioritizedGoalsLimitReached';
import { useParticipantQuery } from 'features/participants/hooks';
import { useUserMode } from 'features/user/hooks';

export const useOpenPrioritizedGoalsSettingModal = () => {
  const { email } = useParams();
  const { participant } = useParticipantQuery(email);
  const { userName } = participant;
  const userMode = useUserMode();

  const title =
    userMode === USER_TYPES.COACH
      ? `${userName} already has the maximum prioritized goals`
      : 'You have reached the maximum number of prioritized goals';

  const openPrioritizedModal = useOpenPrioritizedModal();
  const isPrioritizedGoalsLimitReached = usePrioritizedGoalsLimitReached();

  const openPrioritizedGoalsLimitReachedModal =
    useOpenPrioritizedGoalsLimitReachedModal({
      title,
      onSubmit: openPrioritizedModal,
    });

  if (isPrioritizedGoalsLimitReached) {
    return openPrioritizedGoalsLimitReachedModal;
  } else {
    return openPrioritizedModal;
  }
};
